<template>
    <nav v-if="routeName !== 'Kalender'" class="navbar navbar-expand-lg navbar-light">
        <div class="container-fluid">
            <a class="navbar-brand" href="#">{{ routeName }}</a>
            <button class="navbar-toggler navbar-burger" type="button" @click="toggleSidebar" :aria-expanded="$sidebar.showSidebar" aria-label="Toggle navigation">
                <span class="navbar-toggler-bar"></span>
                <span class="navbar-toggler-bar"></span>
                <span class="navbar-toggler-bar"></span>
            </button>
            <div class="collapse navbar-collapse">
                <ul class="navbar-nav ml-auto">
                    <!-- <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="ti-panel"></i>
              <p>Stats</p>
            </a>
          </li> -->
                    <!-- <drop-down class="nav-item"
                     title="5 Notifications"
                     title-classes="nav-link"
                     icon="ti-bell">
            <a class="dropdown-item" href="#">Notification 1</a>
            <a class="dropdown-item" href="#">Notification 2</a>
            <a class="dropdown-item" href="#">Notification 3</a>
            <a class="dropdown-item" href="#">Notification 4</a>
            <a class="dropdown-item" href="#">Another notification</a>
          </drop-down> -->
                    <!-- <li v-if="isLoggedIn"><center>{{currentUser}}</center></li> -->
                    <li v-if="!isLoggedIn" class="nav-item">
                        <router-link to="/login"
                            ><p class="nav-link"><i class="ti-user"></i>Login</p></router-link
                        >
                    </li>
                    <li v-if="isLoggedIn" class="nav-item"><button v-on:click="logout" class="btn black">Logout</button></li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
    import firebase from "firebase"

    export default {
        computed: {
            routeName() {
                const { name } = this.$route
                return this.capitalizeFirstLetter(name)
            }
        },
        data() {
            return {
                activeNotifications: false,
                isLoggedIn: false,
                currentUser: false
            }
        },
        created() {
            if (firebase.auth().currentUser) {
                this.isLoggedIn = true
                this.currentUser = firebase.auth().currentUser.email
            }
        },

        methods: {
            logout: function () {
                firebase
                    .auth()
                    .signOut()
                    .then(() => {
                        this.$router.go({ path: this.$router.path })
                    })
            },
            capitalizeFirstLetter(string) {
                return string.charAt(0).toUpperCase() + string.slice(1)
            },
            toggleNotificationDropDown() {
                this.activeNotifications = !this.activeNotifications
            },
            closeDropDown() {
                this.activeNotifications = false
            },
            toggleSidebar() {
                this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
            },
            hideSidebar() {
                this.$sidebar.displaySidebar(false)
            }
        }
    }
</script>
<style></style>
